import { useEffect, useState } from 'react';
import { IFile, RagScanStatus } from '../../api-client/autogenerated';
import { getFileById } from '../../models/api/files';

// The autogenerated frontend enum loses the backend's semantic member names
// (backend: RagScanStatus.SUCCESS = 2). NUMBER_2 is that same value.
export const RAG_SCAN_STATUS_SUCCESS = RagScanStatus.NUMBER_2;

const POLL_INTERVAL_MS = 5000;

export const isFileRagScanComplete = (status: RagScanStatus | null | undefined) =>
  status === RAG_SCAN_STATUS_SUCCESS;

/**
 * Tracks a file's `ragScanStatus`, polling `getFileById` every few seconds until
 * it reaches SUCCESS (2). Local to the calling component — does not write back
 * to the shared document/file redux state.
 */
export const useFileRagScanStatus = (file: IFile): RagScanStatus | null | undefined => {
  const [status, setStatus] = useState<RagScanStatus | null | undefined>(file.ragScanStatus);

  useEffect(() => {
    setStatus(file.ragScanStatus);
  }, [file.id, file.ragScanStatus]);

  useEffect(() => {
    if (isFileRagScanComplete(status)) return undefined;
    const interval = setInterval(async () => {
      const updated = await getFileById(file.id);
      setStatus(updated.ragScanStatus);
      if (isFileRagScanComplete(updated.ragScanStatus)) clearInterval(interval);
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [file.id, status]);

  return status;
};
